import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowRight, RotateCcw } from 'lucide-react';
import { Button, Card } from '@/components/ui';
import { Logo } from '@/components/layout';

export function CreditPurchaseCancelPage() {
  // searchParams available for future use (e.g., purchase_id tracking)
  const [_searchParams] = useSearchParams();
  void _searchParams;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Logo size="md" linkTo="/" />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <Card className="max-w-md w-full text-center p-8">
          <div className="w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-warning" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Purchase Cancelled</h1>
          <p className="text-text-secondary mb-6">
            Your credit purchase was cancelled. No charges have been made to your account.
            You can try again whenever you're ready.
          </p>

          <div className="space-y-3">
            <Link to="/dashboard/plans" className="block">
              <Button variant="primary" className="w-full" leftIcon={<RotateCcw className="w-4 h-4" />}>
                Try Again
              </Button>
            </Link>
            <Link to="/dashboard" className="block">
              <Button variant="secondary" className="w-full" rightIcon={<ArrowRight className="w-4 h-4" />}>
                Return to Dashboard
              </Button>
            </Link>
          </div>
        </Card>
      </main>

      {/* FAQ Section */}
      <section className="border-t border-border py-8 px-4">
        <div className="max-w-md mx-auto text-center">
          <h2 className="font-semibold mb-3">Need Help?</h2>
          <p className="text-text-secondary text-sm mb-4">
            If you're experiencing issues with checkout or have questions about our credit packs,
            we're here to help.
          </p>
          <a href="mailto:contact@vettis.ai" className="text-primary hover:underline text-sm">
            Contact Support
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border py-6 px-4 text-center">
        <p className="text-text-muted text-sm">
          &copy; {new Date().getFullYear()} Vettis. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

